module.exports = __webpack_public_path__ + "img/inventoryGuide.125342be.jpg";